$('.js-formExtendedToggle').on('click', (e) => {
  const current = $(e.currentTarget)
  const extendedBody = $('.form-extended__body')

  current.toggleClass('is_active')
  extendedBody.toggle()
})
